import { em } from "polished";
import styled, { css } from "styled-components";

interface IProps {
  size?: string;
}

export const ScrollTable = styled.div`
  @media (max-width: ${em("480px")}) {
    /* @media (max-width: ${({ theme }) => theme.breakpoints[4]}) { */
    overflow-x: auto;

    table {
      width: 48rem;
    }
  }
`;

const Table = styled.table<IProps>`
  width: 100%;
  border: 0;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.fontSizes[2]};

  th,
  td {
    border-bottom: ${({ theme }) => `${theme.borders[5]}`};
    background-color: ${({ theme }) => theme.colors.secondary};
    font-weight: bold;

    ${({ size }) =>
      size === "lg" &&
      css`
        padding: ${({ theme }) => `${theme.space[3]} ${theme.space[2]}`};
      `}
  }

  th {
    padding: ${({ theme }) => `${theme.space[1]} ${theme.space[2]}`};
    border-bottom: ${({ theme }) => `${theme.borders[1]}`};
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    text-align: start;
    text-wrap: wrap;

    @media (max-width: ${({ theme }) => theme.breakpoints[4]}) {
      word-wrap: none;
    }
  }

  tr {
    background-color: ${({ theme }) => theme.colors.white};
  }

  td {
    padding: ${({ theme }) => `${theme.space[2]}`};
  }

  td:first-of-type {
    border-left: ${({ theme }) => `${theme.borders[1]}`};
  }

  td:last-of-type {
    border-right: ${({ theme }) => `${theme.borders[1]}`};
  }

  tr:last-of-type td {
    border-bottom: 0;
  }
`;

export default Table;
